export default __webpack_public_path__ + "static/media/contact_plane_top.1f160e3b.svg";